import * as React from "react";
import {useState} from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  NativeSelect,
  Typography,
} from "@material-ui/core";
import {createStyles, makeStyles, styled, Theme} from "@material-ui/core/styles";
import {primaryBlue, primaryGray, textBarColor, white,} from "src/components/colors";
import {BootstrapInput} from "../../product-types/add-new-firmware/steps/Step1";
import {environment} from "src/environments/environment";
import {AddIconTwo, CancelIcon, DeleteIcon, EditIconTwo, ExpandIconTwo, ViewIconTwo} from "src/components/Icons";

export function AddCommands(props) {
  const classes = useStyles();
  const [selectedParameter, setSelectedParameter] = useState({
      parameter: "",
      parameterId: "",
      inputType: "",
      format: "",
      defaultValue: "",
      joinParameter: "",
      parameterCategory: "",
      isCommand:false,
      commandType:""
    
  });
    
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [parameterToDelete, setParameterToDelete] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);

  const openDeleteDialog = (parameter) => {
    console.log("Opening delete dialog for parameter:", parameter);
    setParameterToDelete(parameter);
    setOpenDeleteConfirm(true);
  };

  const handleDeleteConfirm = () => {
    console.log("parameterToDelete", parameterToDelete)
    props.deleteParameter(parameterToDelete);
    setOpenDeleteConfirm(false);
    setParameterToDelete(null);
  };

  const handleDeleteCancel = () => {
    console.log("Delete cancelled");
    setOpenDeleteConfirm(false);
    setParameterToDelete(null);
  };

  const openView = (parameter) => {
      setSelectedParameter(parameter);
      setIsViewOpen(true);
  };

  const closeView = () => {
    setIsViewOpen(false); 
  }
  const isCommandsAdded=props.parameters.filter(param => param.isCommand === true).length > 0;

  return (
    <Grid container className={classes.container}>
      <Grid container style={{ backgroundColor: 'white', alignItems: 'flex-start',minHeight:"200px",paddingTop:"10px" }}>
        {!isViewOpen && (<>{props.isEditDelete?
          <Grid item xs={12} md={12} style={{textAlign: "right"}}>
            <Button
              className={classes.addButton}
              variant="outlined"
              onClick={() =>
                props.open("add-new",-1)
              }
              startIcon={<AddIconTwo color='#2A7CED'/>}
            >
              ADD
            </Button>
          </Grid>:""}
          <Grid
            hidden={
              isCommandsAdded
                ? false
                : true
            }
            item
            xs={6}
            md={6}
            style={{
              textAlign: "left",
              paddingTop: "25px",
              paddingLeft: "10px",
              paddingBottom: "20px",
            }}
          >
                  <Typography className={classes.topicParameters}>PARAMETERS</Typography>
          </Grid>
          <Grid
            hidden={
              isCommandsAdded
                ? false
                : true
            }
            item
            xs={6}
            md={6}
            style={{textAlign: "center", paddingTop: "25px"}}
          >
                  <Typography className={classes.topicAction} style={{ textAlign: 'end', paddingRight: '60px' }}>ACTION</Typography>
          </Grid></>)}
           {!isViewOpen && !isCommandsAdded && (
            <Grid item xs={12} md={12} style={{ textAlign: "center", paddingTop: "50px", paddingBottom: "50px" }}>
              <Typography style={{ color: primaryGray, fontSize: "14px" }}>
                No Commands Added
              </Typography>
            </Grid>
          )}
          {!isViewOpen && props.parameters.map((parameter, i) => {
            return (
              parameter.isCommand !=null&& parameter.isCommand === true && (
            
                <Grid
                  container
                  key={i}
                  style={{
                    backgroundColor:
                      i % 2 === 0 || i / 2 === 0 ? "#F9F9F9" : "white",
                    textAlign: "left",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                  }}
                >
                  <Grid item xs={6} md={6}>
                          <Typography style={{ paddingLeft: "50px" }}>
                      {parameter.parameter}
                    </Typography>
                  </Grid>
                        <Grid item xs={6} md={6} style={{ textAlign: "end", paddingRight: '60px'}}>
                    <IconButton
                      style={{padding: "0px"}}
                      onClick={() =>
                              openView(parameter)
                      }
                    >
                      <ViewIconTwo/>
                    </IconButton>
                    {props.isEditDelete&&
                    <>
                    <IconButton
                      style={{marginLeft: "10px", padding: "0px"}}
                      onClick={() =>
                        props.open( "edit", i)
                      }
                    >
                            <EditIconTwo />
                          </IconButton>
                          <IconButton
                            style={{ marginLeft: "10px", padding: "0px" }}
                            onClick={() => openDeleteDialog(i)}
                          >
                            <DeleteIcon />
                    </IconButton>
                    </>}
                  </Grid>
                </Grid>
              )
            
          )})}
         
    
          {isViewOpen && (
              <Grid container style={{ padding: "20px", backgroundColor: 'white'}}>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >Command Name</Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >Command ID</Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >Input Type</Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >Data Format</Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >command Value</Typography>
                </Grid>
                <Grid item xs={2} md={2}>
                  <Typography className={classes.topic} style={{ color: primaryGray, fontSize: "14px", }} >Command type</Typography>
                </Grid>
                <Grid container>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.parameter != "" ? selectedParameter.parameter : "N/A"}
                  </Grid>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.parameterId != "" ? selectedParameter.parameterId : "N/A"}
                  </Grid>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.inputType != "" ? selectedParameter.inputType : "N/A"}
                  </Grid>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.format != "" ? selectedParameter.format : "N/A"}
                  </Grid>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.defaultValue != "" ? selectedParameter.defaultValue : "N/A"}
                  </Grid>
                  <Grid item xs={2} md={2}>
                    {selectedParameter.commandType != "" ? selectedParameter.commandType : "N/A"}
                  </Grid>
                  <Grid item xs={12} md={12} style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '20px' }}>
                    <Button className={classes.backButton} variant="contained" onClick={() => closeView()}>Back</Button>
                  </Grid>
                </Grid>
              </Grid>)}
            








      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteConfirm}
        onClose={handleDeleteCancel}
        aria-labelledby="confirmation-dialog-title"
        aria-describedby="confirmation-dialog-description"
      >
        <Grid item className={classes.dialogContainer}>
          <DialogTitle className={classes.dialogTitle}>
            {"Are you sure you want to delete this command?"}
          </DialogTitle>
          <IconButton className={classes.iconStyle} onClick={handleDeleteCancel}>
            <CancelIcon />
          </IconButton>
        </Grid>

        <DialogContent>
          <Box>
            <Grid item className={classes.dialogContentBox}>
              <DialogContentText id="confirmation-dialog-description">
                This action cannot be undone. Please confirm if you'd like to delete this command.
              </DialogContentText>
            </Grid>

            <Grid container justifyContent="flex-end">
              <Grid item className={classes.buttonContainer}>
                <Button variant="outlined" className={classes.cancelButton} onClick={handleDeleteCancel}>
                  Cancel
                </Button>
                <Button variant="contained" className={classes.deleteButton} onClick={handleDeleteConfirm}>
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
      </Dialog>

      {props.parametersAddedError === true && (
        <FormHelperText className={classes.helperText}>
          Remote Configurations/commands not added *
        </FormHelperText>
      )}
    </Grid>
    </Grid>)
    }
  

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    container: {
      paddingTop: "20px",
    },
    clone: {
      fontSize: "14px",
    },
    subIconButtonDiv: {
      backgroundColor: "#F5F5F5",
      width: "25px",
      height: "25px",
      borderRadius: "100%",
      textAlign: "center",
    },
    topic: {
      fontWeight: "bold",
      fontSize: "14px",
    },
    topicParameters: {
      paddingLeft: '40px'
    },
    topicAction: {
      textAlign: 'end',
      paddingRight: '60px'
    },
    addButton: {
      backgroundColor: white,
      color: primaryBlue,
      borderColor: primaryBlue,
    },
    backButton: {
      color: primaryGray,
      width: '100px',
      borderRadius: '4px',
      backgroundColor: 'transparent',
      boxShadow: "none",
      border: "1px solid #707070",
      "&:hover": {
        backgroundColor: "transparent",
        color: primaryGray,
        boxShadow: "none",
      },
    },
    clonedAlready: {
      color: "blue",
      fontSize: "14px",
      marginTop: "10px",
      fontWeight: "bold",
      border: "2px solid blue",
      padding: "8px",
      backgroundColor: "lightblue",
    },
    clonedIndicator: {
      display: "flex",
      alignItems: "center",
      marginTop: "10px",
      fontWeight: "bold",
      backgroundColor: "lightblue",
      padding: "8px",
      borderRadius: "5px",
    },
    clonedIcon: {
      color: "green",
      marginRight: "5px",
    },
    clonedText: {
      fontSize: "14px",
      color: "blue",
    },
    cloneButtonHover: {
      backgroundColor: primaryBlue,
      color: "white",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      },
    },
    helperText: {
      color: "red",
    },
    input: {
      width: "100%",
      height: "40px",
      backgroundColor: textBarColor,
    },
    label: {
      color: "#324054A6",
      paddingBottom: "5px",
    },
    dialogContainer: {
      display: 'flex',
      flexDirection: 'row',
      boxShadow: '0 0 15px 0 #00000014',
    },
    dialogTitle: {
      width: '90%',
    },
    iconStyle: {
      justifyContent: "flex-end",
      cursor: "pointer",
    },
    dialogContentBox: {
      marginBottom: '15px',
      padding: '10px',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '40%',
      marginBottom: '10px',
      gap: '10px',
    },
    cancelButton: {
      flexGrow: 1,
    },
    deleteButton: {
      backgroundColor: '#FF4343',
      color: 'white',
    }
  })
);




